/*
  Mesa Collection motion layer (Option B).
  - Scroll reveal: top-level content of each section fades up as it enters the viewport, staggered.
  - Images ease out of a slight zoom when revealed.
  - Quote rotator: [data-mesa-rotator] cycles quotes, with name buttons to jump between them.
  Disabled for prefers-reduced-motion and inside the theme editor.
*/
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = window.Shopify && window.Shopify.designMode;

  function initRotators(root = document) {
    root.querySelectorAll('[data-mesa-rotator]:not([data-mesa-ready])').forEach((rotator) => {
      rotator.setAttribute('data-mesa-ready', '');
      const slides = [...rotator.querySelectorAll('[data-mesa-slide]')];
      const dots = [...rotator.querySelectorAll('[data-mesa-dot]')];
      if (slides.length < 2) return;
      let index = 0;
      let timer;

      const show = (next) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === index);
          slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', i === index ? 'true' : 'false'));
      };
      const start = () => {
        if (reduceMotion || designMode) return;
        clearInterval(timer);
        timer = setInterval(() => show(index + 1), 6000);
      };

      dots.forEach((dot, i) =>
        dot.addEventListener('click', () => {
          show(i);
          start();
        })
      );
      rotator.addEventListener('mouseenter', () => clearInterval(timer));
      rotator.addEventListener('mouseleave', start);
      show(0);
      start();
    });
  }

  function initReveal() {
    if (reduceMotion || designMode || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('mesa-motion');

    // Top-level blocks of each section only, so carousels and grids fade in as one unit
    // (their off-screen slides never intersect the viewport on their own).
    const targets = [
      ...document.querySelectorAll(
        [
          'main .shopify-section:not([id*="hero_slideshow"]) .section-content-wrapper > *',
          'main .shopify-section .mesa-reveal-group > *',
        ].join(',')
      ),
    ].filter((el) => !['STYLE', 'SCRIPT', 'LINK', 'TEMPLATE'].includes(el.tagName) && el.getClientRects().length > 0);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    targets.forEach((el) => {
      if (el.closest('.mesa-no-reveal') || el.classList.contains('mesa-reveal')) return;
      const siblings = [...el.parentElement.children];
      el.style.setProperty('--mesa-delay', `${Math.min(siblings.indexOf(el), 6) * 90}ms`);
      el.classList.add('mesa-reveal');
      observer.observe(el);
    });
  }

  const boot = () => {
    initRotators();
    initReveal();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', (event) => initRotators(event.target));
})();
